import api from '@/composables/useApiFactory'
import type { UserT } from '@/types/User'

const UserService = {
  async getProfile() {
    return api().get<UserT>(`/auth/profile/`)
  },

  async updatePassword({ oldPassword, newPassword }: { oldPassword: string; newPassword: string }) {
    return api().put<any, ApiResponseT<any>>('/auth/password', { oldPassword, newPassword })
  },

  async updateProfile({
    firstName,
    lastName,
    dateOfBirth,
    avatarUrl,
    email,
    schoolId
  }: {
    firstName: string
    lastName: string
    dateOfBirth: string
    avatarUrl: string

    email: string
    schoolId: string
  }) {
    return api().put<any, ApiResponseT<UserT>>('/users/me', { firstName, lastName, dateOfBirth, avatarUrl, ...(email ? { email } : {}), ...(schoolId ? { schoolId } : {}) })
  },

  async deleteAccount() {
    return api().delete<any, ApiResponseT<any>>('/users/me')
  }
}

export default UserService
